var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 384 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M352 128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h146.7L41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 205.3V352c0 17.7 14.3 32 32 32s32-14.3 32-32V128z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }